import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
import { faqs } from '../data/mock';
import ContactFormSection from './ContactFormSection';
import { useLang } from '../context/LanguageContext';

export default function FAQSection() {
  const { t } = useLang();
  const [open, setOpen] = useState(0);
  return (
    <section className="py-24 bg-white">
      <div className="max-w-[1280px] mx-auto px-6 grid grid-cols-1 lg:grid-cols-2 gap-14">
        <div>
          <p className="section-eyebrow mb-4">{t('faq.eyebrow')}</p>
          <h2 className="text-[36px] md:text-[44px] leading-[1.1] font-extrabold text-[#14110f]">
            {t('faq.titlePre')} <br />{t('faq.your')} <span className="text-[#f5b300]">{t('faq.titleAccent')}</span>
          </h2>
          <p className="mt-5 text-[15.5px] text-neutral-600 leading-relaxed max-w-md">{t('faq.desc')}</p>

          <div className="mt-8 space-y-3">
            {faqs.map((f, i) => {
              const isOpen = open === i;
              return (
                <div
                  key={f.id}
                  className={`rounded-xl border transition-all ${
                    isOpen ? 'bg-[#4a2e1a] border-[#4a2e1a]' : 'bg-[#faf6ec] border-transparent hover:border-[#f5b300]/40'
                  }`}
                >
                  <button
                    onClick={() => setOpen(isOpen ? -1 : i)}
                    className={`w-full text-left flex items-center justify-between gap-4 px-5 py-4 ${
                      isOpen ? 'text-white' : 'text-[#14110f]'
                    }`}
                  >
                    <span className="font-semibold text-[15px]">{t(`faq.${f.id}.q`)}</span>
                    <span
                      className={`w-8 h-8 rounded-full flex items-center justify-center shrink-0 transition-all ${
                        isOpen ? 'bg-[#f5b300] text-[#14110f]' : 'bg-white text-[#14110f]'
                      }`}
                    >
                      {isOpen ? <Minus className="w-4 h-4" /> : <Plus className="w-4 h-4" />}
                    </span>
                  </button>
                  {isOpen && (
                    <div className="px-5 pb-5 text-[14px] leading-relaxed text-white/75">{t(`faq.${f.id}.a`)}</div>
                  )}
                </div>
              );
            })}
          </div>
        </div>

        <ContactFormSection inline />
      </div>
    </section>
  );
}
